(ns livefeed.message-status
  (:require
   [reagent.core :as reagent :refer [atom]]
   [livefeed.i18n :refer [translate]]))

(defonce status (reagent/atom :ready))

(defonce unbanned-at (reagent/atom nil))

(def notification-on-display-delay 3000)

(defn ban-ended? []
  (let [unban-ts @unbanned-at]
    (and (not (nil? unban-ts)) (< unban-ts (js/Date.)))))

(defn banned? []
  (= :blocked @status))

(defn ready-to-send? []
  (or (= :ready @status)
      (and (banned?)
           (ban-ended?))))

(defn done! []
  (reset! unbanned-at nil)
  (reset! status :ready))

(defn- parse-status [type]
  (cond
    (= type "rejected-comment") :rejected
    (= type "accepted-comment") :accepted
    :else :failed))

(defn notify! [{:keys [type]}]
  (let [next-status (parse-status type)]
    (reset! status next-status)
    (js/setTimeout done! notification-on-display-delay)))

(defn send-failed []
  (reset! status :failed)
  (js/setTimeout done! notification-on-display-delay))

(defn sent-to-moderation! []
  (reset! status :moderating))

(defn topic-locked! []
  (reset! status :topic-locked))

(defn topic-unlocked! []
  (swap! status (fn [old-status]
                  (if (= old-status :topic-locked)
                    :ready
                    old-status))))

(defn connection-error! []
  (reset! status :connection-error))

(defn not-found! []
  (reset! status :not-found))
